import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

export default function SiteFooter() {
  return (
    <footer id="contactos" className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <a href="#home" className="inline-block mb-4">
              <span className="text-xl font-bold text-white">Electro Salir Lda.</span>
            </a>
            <p className="text-slate-400 text-sm mb-1">NIF 502 529 962</p>
            <p className="text-slate-400 max-w-md">
              Soluções de climatização, ar condicionado e painéis solares. Dedicação e esforço pelo seu conforto.
            </p>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Contactos</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-gestao-primary shrink-0 mt-0.5" />
                <span>
                  Rua Manuel Dourado Eusébio N.º 34 A, Salir, Portugal, 8100-202
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-gestao-primary shrink-0" />
                <a href="tel:+351289489848" className="hover:text-white">289 489 848</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-gestao-primary shrink-0" />
                <a href="tel:+351917869307" className="hover:text-white">917 869 307</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-gestao-primary shrink-0" />
                <a href="mailto:electrosalir@sapo.pt" className="hover:text-white">electrosalir@sapo.pt</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Electro Salir. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap justify-center sm:justify-end gap-4 sm:gap-6 text-sm">
            <Link to="/termos-e-condicoes" className="text-slate-400 hover:text-white">
              Termos e Condições
            </Link>
            <Link to="/politica-de-privacidade" className="text-slate-400 hover:text-white">
              Política de Privacidade
            </Link>
            <a
              href="https://www.livroreclamacoes.pt/Pedido/ElogioSugestao"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-white"
            >
              Livro do Elogio/Sugestão
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
